<template>
  <rest
    ref="restComponent"
    :remote="remote"
    :table-columns="tableColumns"
    :form-initialize="formInitialize"
    :form-rules="formRules"
    :exportable="true"
    :create-able="true" :update-able="true" :delete-able="true"
    :listeners="listeners"
  >
  <template slot="tableColumn-menuArgs" slot-scope="{row}">
      <el-button type="primary" plain size="mini" @click="showMenuDetail(row)">查看菜单</el-button>
      <el-dialog
        :title="`菜单配置 (游戏ID: ${dialogInfo[row.id]?.appId || ''}, 渠道ID: ${dialogInfo[row.id]?.channelId || ''})`"
        :visible.sync="dialogVisible[row.id]"
        width="30%"
        center
        :append-to-body="true"
        custom-class="menu-dialog">
        <el-descriptions border :column="1">
          <el-descriptions-item v-for="(menu, index) in dialogInfo[row.id]?.menus || []" :key="index" :label="menu.menuName">
            <div class="menu-url">{{menu.jumpUrl}}</div>
          </el-descriptions-item>
        </el-descriptions>
      </el-dialog>
    </template>
    <template slot="formItem-menuArgs" slot-scope="{item, form}">
      <div v-for="(menu, index) in menuList" :key="index" style="margin-bottom: 10px; display: flex; align-items: center;">
        <el-input v-model="menu.menuName" placeholder="菜单名称" style="width: 200px; margin-right: 10px;"></el-input>
        <el-input v-model="menu.jumpUrl" placeholder="跳转链接" style="width: 400px; margin-right: 10px;"></el-input>
        <el-button type="danger" icon="el-icon-delete" circle @click="removeMenu(index)"></el-button>
      </div>
      <el-button type="primary" icon="el-icon-plus" @click="addMenu" v-if="menuList.length < 4">添加菜单项</el-button>
      <input type="hidden" :value="updateFormMenuArgs(form, item.prop)">
    </template>
  </rest>
</template>

<script>
import Rest from '@/components/Spring/Rest'

export default {
  name: 'uninstallMenus',
  components: { Rest },

  data () {
    return {
      dialogVisible: {},
      dialogInfo: {},
      currentMenus: [],
      remote: {
        path: 'channel',
        resource: this.$options.name,
        realtime: true
      },
      formInitialize: {
        appId: this.$store.getters.appId || '',
        channelId: '',
        menuArgs: '[]'
      },
      formRules: {
        channelId: [{ required: true, message: '请填写渠道ID' }],
        menuArgs: [{ required: true, message: '请填写卸载菜单' }]
      },
      menuList: [],
      listeners: {
        beforeFormEdit: this.beforeFormEdit,
        beforeFormSubmit: this.beforeFormSubmit
      }
    }
  },
  computed: {
    tableColumns () {
      return [
        { label: 'ID', prop: 'id', hiddenForm: true },
        { label: '游戏ID', prop: 'appId', hiddenForm: true },
        { label: '渠道ID', prop: 'channelId' },
        { label: '卸载菜单', prop: 'menuArgs', formType: 'slot', type: 'slot' },
        { label: '创建时间', prop: 'createdAt', type: 'datetime', hiddenForm: true },
        { label: '修改时间', prop: 'updatedAt', type: 'datetime', hiddenForm: true }
      ]
    }
  },
  methods: {
    parseMenuArgs (menuArgsStr) {
      try {
        return JSON.parse(menuArgsStr || '[]')
      } catch (e) {
        console.error('解析菜单参数失败', e)
        return []
      }
    },
    showMenuDetail (row) {
      const menus = this.parseMenuArgs(row.menuArgs)
      this.$set(this.dialogInfo, row.id, {
        menus,
        appId: row.appId,
        channelId: row.channelId
      })
      this.$set(this.dialogVisible, row.id, true)
    },
    addMenu () {
      if (this.menuList.length < 4) {
        this.menuList.push({ menuName: '', jumpUrl: '' })
      }
    },
    removeMenu (index) {
      this.menuList.splice(index, 1)
    },
    updateFormMenuArgs (form, prop) {
      form[prop] = JSON.stringify(this.menuList)
      return form[prop]
    },
    beforeFormEdit (form) {
      try {
        if (form.menuArgs) {
          this.menuList = JSON.parse(form.menuArgs)
        } else {
          this.menuList = []
          this.addMenu()
        }
      } catch (e) {
        this.menuList = []
        this.addMenu()
        console.error('解析菜单配置失败', e)
      }
    },
    beforeFormSubmit (form) {
      form.appId = this.$store.getters.appId || form.appId
      form.menuArgs = JSON.stringify(this.menuList)
    }
  },
  mounted () {
    this.$root.$on('rest-dialog-visible', (visible, formModel) => {
      if (visible && formModel) {
        this.menuList = this.parseMenuArgs(formModel.menuArgs)
      }
    })
  }
}
</script>
